import * as React from "react";
import { Query } from "react-apollo";
import { Helmet } from "react-helmet";
import styled from "@emotion/styled";

// GraphQL
import GetUserDetails from "../../GraphQL/Queries/GetUserDetails";

// Presentation/UI
import BackendWrapper from "../../Components/Layouts/BackendWrapper";
import Loader from "../../Components/Loader/DotLoader";

// Local components
import WorkOrders from "./WorkOrderChartReports";
import CustomerRequests from "./CustomerRequestsChartReports";

// Utils
import { getUserId } from "../../Utils/Helpers";

const userId = getUserId().userId;

const Header = styled.h6`
  margin-left: 20px;
  margin-right: 20px;
`;

class Reports extends React.Component<{}> {
  render() {
    return (
      <Query query={GetUserDetails} variables={{ id: userId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the user details</div>;
          }

          const companyId = data.User.company.id;

          return (
            <BackendWrapper>
              <Header>Work Orders Chart Reports</Header>
              <WorkOrders companyId={companyId} />

              <Header>Customer Request Chart Reports</Header>
              <CustomerRequests companyId={companyId} />
              <Helmet title="Reports" />
            </BackendWrapper>
          );
        }}
      </Query>
    );
  }
}

export default Reports;



// WEBPACK FOOTER //
// ./src/Containers/Reports/index.tsx